module.exports = {
  lang: 'cn',
  message: {
    hello: '你好',
    about: '关于',
    welcome: "欢迎"
  },
  nav: [{
    name: '网站首页',
    url: '/',
  },
  {
    name: '关于我们',
    url: '/about',
  },
  {
    name: '产品中心',
    url: '/product',
  },
  {
    name: '新闻资讯',
    url: '/news',
  },
  {
    name: '联系我们',
    url: '/contact',
  },
  ],
  title: {
    about: `关于<em>我们</em><span>About</span>`,
    product: `产品<em>中心</em><span>Products</span>`,
    news: `新闻<em>资讯</em><span>News</span>`,
    contact: ` 联系<em>我们</em><span>contact</span>`
  },
  more: {
    value: '查看更多'
  },
  nav_foot: [{
    name: '关于我们',
    url: 'about',
    subnavigation: [{
      subname: '公司简介',
      id: '',
      url: 'about'
    },
    {
      subname: '企业荣誉',
      id: 'honour',
      url: 'honor'
    }
    ]
  },
  {
    name: '产品中心',
    url: 'product',
    subnavigation: [{
      name: '全部',
      id: ''
    }
      // {
      // subname: '可再分散性乳胶',
      // id: 1
      // },
      // {
      // subname: '单组份木胶粉',
      // id: 2
      // },
      // {
      // subname: '纯脲醛树脂原粉',
      // id: 3
      // },
      // {
      // subname: '环保型脲醛树脂原粉',
      // id: 4
      // }
    ]
  },
  {
    name: '新闻资讯',
    url: 'news',
    subnavigation: [{
      subname: '公司新闻',
      id: '',
      url: 'company'
    },
    {
      subname: '行业资讯',
      id: 'industry',
      url: 'industry'
    }
    ]
  }
  ],
  addressInfo: {
    name: '联系我们',
    address: '地址：浙江省湖州市杨家埠果木园路118号',
    hotline: '资讯热线：',
    mailbox: '公司邮箱：',
    website: '公司网站：'
  },
  contact: {
    name: '湖州璟宝新型建材有限公司',
    address: '地址：',
    hotline: '电话：',
    mailbox: '邮箱：',
    zipcode: '邮编：',
    cellphone: '手机：',
    fax: '传真：'
  },
  mteaTitle: {
    index: "木工胶,木胶粉,乳胶粉,可再分散乳胶粉,木工胶粉,脲醛树脂,脲醛树脂胶粉-湖州璟宝新型建材官方网站",
    //index:'主营产品木胶粉、可再分散性乳胶粉-湖州璟宝新型建材官方网站',
    product: '湖州璟宝建材生产木胶粉、可再分散性乳胶粉、木工胶粉、脲醛树脂胶粉是新型建材粘合剂产品'
  },
  keyword: {
    index: "乳胶粉,可再分散乳胶粉,木胶粉,网洞高分子胶粉,脲醛树脂胶粉,木工胶,脲醛树脂,木工胶粉",
    product: "乳胶粉,可再分散乳胶粉,木胶粉,网洞高分子胶粉,脲醛树脂胶粉,木工胶,脲醛树脂,木工胶粉"
  },
  Copyright: {
    key: '版权所有',
    value: '浙ICP备14020741号'
  },
  productnav: [
    {
      p1: "乳胶粉",
      url: "/home"
    },
    {
      p1: "可再分散乳胶粉",
      url: "/home"
    },
    {
      p1: "木胶粉",
      url: "http://www.hzjingbao.cn/index.html#/product/dtails/4"
    },
    {
      p1: "网洞高分子胶粉",
      url: "/home"
    },
    {
      p1: "脲醛树脂胶粉",
      url: "http://www.hzjingbao.cn/index.html#/product/dtails/10"
    },
    {
      p1: "木工胶",
      url: "http://www.hzjingbao.cn/index.html#/news/details/60"
    },
    {
      p1: "脲醛树脂",
      url: "/home"
    },
    {
      p1: "木工胶粉",
      url: "http://www.hzjingbao.cn/index.html#/news/details/61"
    }
  ]
}



//////////////////
// WEBPACK FOOTER
// ./static/lang/zh.js
// module id = z8sE
// module chunks = 1